export default "__VITE_ASSET__CN7XANy$__"